import { Component } from '@theme/component';
import { ThemeEvents } from '@theme/events';

class ShippingProgressBar extends Component {
  connectedCallback() {
    super.connectedCallback();
    
    if (document.readyState === 'complete' || document.readyState === 'interactive') {
      this.init();
    } else {
      window.addEventListener('load', () => this.init());
    }

    document.addEventListener(ThemeEvents.cartUpdate, (event) => {
      this.init();
      console.log(event)
    });
  }

  async init() {
      try {
        this.response = await fetch(`${window.Shopify.routes.root}cart.js`);
        this.cartData = await this.response.json();
        console.log('Cart Data:', this.cartData);
        this.renderBar(this.cartData);
      } catch (e) {
        console.error('ShippingBar: Fetch failed', e);
      }
  }

   renderBar(cart) {
    if (!cart) return;
    this.goal = parseInt(this.getAttribute('data-goal'));
    this.total = cart.total_price;
    this.remaining = this.goal - this.total;
    this.percentage = Math.min((this.total / this.goal) * 100, 100);
    this.progressBar = this.querySelector('#progress-bar-fill');
    this.message = this.querySelector('#shipping-message');
    if (!this.progressBar || !this.message) return;
    this.progressBar.style.width = `${this.percentage}%`;
    if (this.remaining > 0) {
      this.formatted = (this.remaining / 100).toLocaleString('en-US', {
        style: 'currency',
        currency: cart.currency || 'USD',
      });
      this.message.innerHTML = `You’re <strong>${this.formatted}</strong> away from Free Shipping`;
    } else {
      this.message.innerHTML = "🎉 You've unlocked <strong>Free Shipping!</strong>";
      this.progressBar.style.width = '100%';
    }
  }
}

if (!customElements.get('shipping-progress-bar')) {
  customElements.define('shipping-progress-bar', ShippingProgressBar);
}

class UpsellCarousel extends Component {
  connectedCallback() {
    setTimeout(() => this.init(), 500);
    document.addEventListener(ThemeEvents.cartUpdate, () => {
      setTimeout(() => this.init(), 50);
    });
  }

  init() {
    if (this.swiperInstance) {
      this.swiperInstance.destroy(true, true);
    }
    const settingsAttr = this.getAttribute('data-settings');
    let customSettings = {};

    try {
      customSettings = settingsAttr ? JSON.parse(settingsAttr) : {};
    } catch (e) {
      console.error('UpsellCarousel: JSON parse error', e);
    }
    const defaults = {
      grabCursor: true,
      observer: true,
      observeParents: true,
      pagination: {
        el: this.querySelector('.swiper-pagination'),
        clickable: true,
      },
      navigation: {
        nextEl: this.querySelector('.swiper-button-next'),
        prevEl: this.querySelector('.swiper-button-prev'),
      },
    };
    const finalConfig = { ...defaults, ...customSettings };
    if (typeof Swiper !== 'undefined') {
      this.swiperInstance = new Swiper(this, finalConfig);
      this.swiperInstance.update();
    }
  }
}

if (!customElements.get('upsell-carousel')) {
  customElements.define('upsell-carousel', UpsellCarousel);
}
document.addEventListener('click', async (e) => {
  const button = e.target.closest('.btn-quick-add');
  if (!button || button.disabled) return;

  const variantId = button.dataset.variantId;
  const originalText = button.innerHTML;
  
  button.innerHTML = 'ADDING...';
  button.disabled = true;

  try {
    const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        items: [{ id: variantId, quantity: 1 }],
        sections: document.querySelector('cart-items-component')?.dataset.sectionId,
      }),
    });

    const data = await response.json();
    button.innerHTML = 'ADDED!';

    document.dispatchEvent(
      new CustomEvent(ThemeEvents.cartUpdate, {
        detail: { data, source: 'upsell-carousel' },
      })
    );
   
  } catch (error) {
    button.innerHTML = 'ERROR';
    console.error('Add to Cart Error:', error);
  } finally {
    setTimeout(() => {
      button.innerHTML = originalText;
      button.disabled = false;
    }, 800);
  }
});